import i18n from '@/i18n';
import {
  canFitAnyDirection,
  getEnabledDirections,
  isAllDiagonalEnabled,
} from '../strategies/directionUtils';
import { insertWordBasedOnStrategy } from '../insertion/insertBasedOnStrategy';

function getRemainingDirections(engine, word, enabledDirections) {
  const failed = engine.state.failedDirections.get(word) || new Set();
  return enabledDirections.filter(dir => !failed.has(dir));
}

function tryInsertInRemainingDirections({
  engine,
  game,
  word,
  remainingDirections,
  hasAllDiagonalDirections,
}) {
  for (let i = 0; i < remainingDirections.length; i += 1) {
    const direction = remainingDirections[i];

    const inserted = insertWordBasedOnStrategy(
      engine,
      word,
      direction,
      hasAllDiagonalDirections,
      game,
    );

    if (inserted) {
      engine.state.removeUnplaced(word);
      return true;
    }

    engine.state.registerFailure(word, direction);
  }

  return false;
}

export function retryUnplacedWords(engine, game, gameNumber) {
  const enabledDirections = getEnabledDirections(engine.model.settings);
  const hasAllDiagonalDirections = isAllDiagonalEnabled(enabledDirections);
  const { rows, columns } = engine.model;

  const wordsToRetry = [...engine.state.unplacedWords];
  const tooBigWords = [];

  for (let i = 0; i < wordsToRetry.length; i += 1) {
    const word = wordsToRetry[i];

    const fits = canFitAnyDirection(word, enabledDirections, rows, columns);

    if (fits) {
      const remaining = getRemainingDirections(engine, word, enabledDirections);

      if (remaining.length > 0) {
        tryInsertInRemainingDirections({
          engine,
          game,
          word,
          remainingDirections: remaining,
          hasAllDiagonalDirections,
        });
      }
    } else {
      tooBigWords.push(word);
      engine.state.addUnplaced(word);
    }
  }

  if (tooBigWords.length && engine.activeAlert) {
    const listHtml = `<ul>${tooBigWords
      .map(item => `<li>${item}</li>`)
      .join('')}</ul>`;

    engine.activeAlert({
      message: `
      <p>${i18n.t('huntingWordsGenerator.alert.wordsTooBig.intro', { gameNumber })}</p>
      ${listHtml}
    `,
      theme: 'warning',
    });
  }
}
